import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_API_URL || 'http://localhost:8080';

const authHeaders = (accessToken) => ({ Authorization: `Bearer ${accessToken}` });

export async function getDemoSites(accessToken) {
    const res = await axios.get(`${API_URL}/api/demo-sites`, { headers: authHeaders(accessToken) });
    return res.data;
}

export async function createDemoSite(accessToken, data) {
    const res = await axios.post(`${API_URL}/api/demo-sites`, data, { headers: authHeaders(accessToken) });
    return res.data;
}

export async function updateDemoSite(accessToken, id, data) {
    const res = await axios.put(`${API_URL}/api/demo-sites/${id}`, data, { headers: authHeaders(accessToken) });
    return res.data;
}

export async function deleteDemoSite(accessToken, id) {
    const res = await axios.delete(`${API_URL}/api/demo-sites/${id}`, { headers: authHeaders(accessToken) });
    return res.data;
}

export async function uploadDemoSiteImage(accessToken, id, file) {
    const form = new FormData();
    form.append('image', file);
    const res = await axios.post(`${API_URL}/api/demo-sites/${id}/image`, form, {
        headers: { ...authHeaders(accessToken), 'Content-Type': 'multipart/form-data' },
    });
    return res.data;
}

export async function deleteDemoSiteImage(accessToken, id) {
    const res = await axios.delete(`${API_URL}/api/demo-sites/${id}/image`, { headers: authHeaders(accessToken) });
    return res.data;
}

// ── Accès (url + identifiants, plusieurs par site, jamais obligatoires) ────

export async function createDemoSiteAccess(accessToken, data) {
    const res = await axios.post(`${API_URL}/api/demo-site-accesses`, data, { headers: authHeaders(accessToken) });
    return res.data;
}

export async function updateDemoSiteAccess(accessToken, id, data) {
    const res = await axios.put(`${API_URL}/api/demo-site-accesses/${id}`, data, { headers: authHeaders(accessToken) });
    return res.data;
}

export async function deleteDemoSiteAccess(accessToken, id) {
    const res = await axios.delete(`${API_URL}/api/demo-site-accesses/${id}`, { headers: authHeaders(accessToken) });
    return res.data;
}
